export const NO_WELCOME_DIALOG = 'NO_WELCOME_DIALOG_ODTP';
export const WELCOME_DIALOG = 'WelcomeDialog';
